import { render } from "./NumberEditor.vue?vue&type=template&id=4c69d582&scoped=true"
import script from "./NumberEditor.vue?vue&type=script&lang=js"
export * from "./NumberEditor.vue?vue&type=script&lang=js"

import "./NumberEditor.vue?vue&type=style&index=0&id=4c69d582&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c69d582"]])

export default __exports__